
import privateAxiosInstance from "../utils/axios/private";
import { hybridEncrypt, hybridDecrypt } from "../utils/crypto";

/**
 * Candidate-related API calls
 */
export const candidateApi = {
    /**
     * Apply for a job or opportunity
     */
    async apply(payload) {
        try {
            const response = await privateAxiosInstance.post("/candidate/apply/", payload);

            let finalData = response.data;

            if (response.data?.encrypted) {
                finalData = await hybridDecrypt(response.data);
            }

            return {
                status: response.status,                // ✅ FIX
                data: finalData,
                message: finalData?.message,
                success: true,
            };

        } catch (error) {

            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: null,
                    message: "NETWORK_ERROR",
                    success: false,
                };
            }

            return {
                status: error?.response?.status,       // ✅ FIX
                data: error?.response?.data,
                message: error?.response?.data?.message,
                success: false,
            };
        }
    },

    async match(payload) {
        try {

            const response =
                await privateAxiosInstance.post(
                    "/candidate/match/",
                    payload
                );

            let finalData = response.data;

            if (response.data?.encrypted) {
                finalData =
                    await hybridDecrypt(response.data);
            }

            return {
                status: response.status,
                data: finalData,
                success: true,
                message: finalData?.message
            };

        } catch (error) {

            return {
                success: false,
                status: error?.response?.status,
                message:
                    error?.response?.data?.message
            };

        }
    },
    /**
     * Get candidate invitations (jobs/interviews, etc.)
     */
    async getInvitations(payload) {
        try {
            const encryptedPayload = await hybridEncrypt(payload);

            const response = await privateAxiosInstance.post(
                "/candidate/invitations/",
                encryptedPayload
            );

            let finalData = response.data;

            if (response.data?.encrypted) {
                finalData = await hybridDecrypt(response.data);
            }

            return {
                status: response.status,               // ✅ FIX
                data: finalData,
                message: finalData?.message,
                success: true,
            };

        } catch (error) {

            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: null,
                    message: "NETWORK_ERROR",
                    success: false,
                };
            }

            return {
                status: error?.response?.status,      // ✅ FIX
                data: error?.response?.data,
                message: error?.response?.data?.message,
                success: false,
            };
        }
    },

    /**
     * Resend candidate invitations (jobs/interviews, etc.)
     */
    async resendInvitation(payload) {
        try {
            const encryptedPayload = await hybridEncrypt(payload);

            const response = await privateAxiosInstance.post(
                "/candidate/reinvite/",
                encryptedPayload
            );

            let finalData = response.data;

            if (response.data?.encrypted) {
                finalData = await hybridDecrypt(response.data);
            }

            return {
                status: response.status,
                data: finalData,
                message: finalData?.message,
                success: true,
            };

        } catch (error) {

            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: null,
                    message: "NETWORK_ERROR",
                    success: false,
                };
            }

            return {
                status: error?.response?.status,
                data: error?.response?.data,
                message: error?.response?.data?.message,
                success: false,
            };
        }
    },

    async requestReschedule(payload) {
        try {
            const response = await privateAxiosInstance.post("/candidate/reschedule/", payload);

            let finalData = response.data;

            if (response.data?.encrypted) {
                finalData = await hybridDecrypt(response.data);
            }

            return {
                status: response.status,                // ✅ FIX
                data: finalData,
                message: finalData?.message,
                success: true,
            };

        } catch (error) {

            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: null,
                    message: "NETWORK_ERROR",
                    success: false,
                };
            }

            return {
                status: error?.response?.status,       // ✅ FIX
                data: error?.response?.data,
                message: error?.response?.data?.message,
                success: false,
            };
        }
    },

    /**
     * Submit or update pitch information
     */
    async submitPitch(payload) {
        try {
            const encryptedPayload = await hybridEncrypt(payload);
            const response = await privateAxiosInstance.post("/candidate/pitch/", encryptedPayload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /** 
     * Upload profile or resume image
     */
    async uploadImage(formData) {
        try {
            const response = await privateAxiosInstance.post("/candidate/image/upload/", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true
            });

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },



    async validatelink(payload) {
        try {
            const response = await privateAxiosInstance.post("/interview/validate/", payload, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async viewResume(payload) {
        try {
            const response = await privateAxiosInstance.get("/candidate/viewresume/", {
                params: payload
            });

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },
};
